<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <el-form-item label="机器ID">
        <el-input
          v-model="formInline.machineid"
          placeholder="请输入机器ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="使用次数大于">
        <el-input-number
          v-model.trim="formInline.cycleUsageCount"
          :step="10"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <el-form>
      <el-form-item style="margin-left:1.5rem;">
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="machineid"
        label="机器id"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="machineModel"
        label="型号"
        width="170"
      ></el-table-column>
      <el-table-column
        prop="machineName"
        label="名称"
        width="180"
      ></el-table-column>
      <el-table-column prop="shopname" label="所属门店"></el-table-column>
      <el-table-column
        prop="totalUsageCount"
        label="总加液数"
      ></el-table-column>
      <el-table-column
        prop="cycleUsageCount"
        label="周期加液数"
      ></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="resetToZero(scope.row.machineid)"
            >归零</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
//import enumObject from "../../plugins/enum";
// import CreateDialog from "./components/createDialog";
// import Printer from "./components/printer";
// import EditDialog from "./components/editDialog";
// import ControlDialog from "./components/controlDialog";
// //import { mapGetters } from "vuex";
// import moment from "moment";

export default {
  components: {
    // CreateDialog,
    // EditDialog,
    // ControlDialog,
    // Printer
  },
  data() {
    return {
      formInline: {
        machineid: "",
        cycleUsageCount: 0
      },
      tableData: [],
      multipleSelection: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    };
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    onSubmit() {
      let queryModel = {
        machineid: this.formInline.machineid,
        cycleUsageCount: this.formInline.cycleUsageCount,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };

      this.$axios(this.$urlMapping["查询洗衣液"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    resetToZero(machineid) {
      this.$confirm("是否确认归零?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let machineids = [machineid];
        this.$axios(this.$urlMapping["加液归零"], {
          data: {
            machineids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
